<template>
    <div id="app-root">
    </div>
</template>

<script setup>
</script>

<script>
export default {
    name: 'RootComponent',
    mounted() {
        this.$router.push('/getting-started')
    }
}
</script>
